import { computed, ComputedRef } from 'vue';
import { PreviewEvent, PreviewOdd, PreviewOutcome } from '../../types/sport';
import store from '@/store/index';

export const getCorrectData = (
  outcomes: PreviewOutcome[]
): [PreviewOutcome[], PreviewOutcome[], PreviewOutcome[]] => {
  const groupedOutcomes: [
    PreviewOutcome[],
    PreviewOutcome[],
    PreviewOutcome[]
  ] = [[], [], []];

  if (!outcomes || outcomes.length === 0) {
    return groupedOutcomes;
  }

  const extractHomeAway = (o: PreviewOutcome): [number, number] => {
    const alias = (o as any)?.outcome_alias || (o.outcome_name as string);
    const match = alias?.match(
      /^\s*(-?\d+(?:\.\d+)?)\s*-\s*(-?\d+(?:\.\d+)?)\s*$/
    );
    if (!match) return [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY];
    const home = Number(match[1]);
    const away = Number(match[2]);
    return [home, away];
  };

  outcomes.forEach((outcome: PreviewOutcome) => {
    const alias =
      (outcome as any)?.outcome_alias ||
      (outcome.outcome_name as string | undefined);
    if (!alias || typeof alias !== 'string') {
      return;
    }

    const match = alias.match(
      /^\s*(-?\d+(?:\.\d+)?)\s*-\s*(-?\d+(?:\.\d+)?)\s*$/
    );
    if (!match) {
      return;
    }

    const home = Number(match[1]);
    const away = Number(match[2]);
    if (Number.isNaN(home) || Number.isNaN(away)) {
      return;
    }

    if (home > away) {
      groupedOutcomes[0].push(outcome);
    } else if (home === away) {
      groupedOutcomes[1].push(outcome);
    } else {
      groupedOutcomes[2].push(outcome);
    }
  });
  // Ordina ciascuna colonna per valori Home poi Away (crescente)
  groupedOutcomes.forEach(column => {
    column.sort((a, b) => {
      const [ha, aa] = extractHomeAway(a);
      const [hb, ab] = extractHomeAway(b);
      if (ha !== hb) return ha - hb;
      return aa - ab;
    });
  });
  console.log('groupedOutcomes', groupedOutcomes);
  return groupedOutcomes;
};

const useOdds = (eventsGetter: () => PreviewEvent) => {
  const columns = computed(() => {
    const event = eventsGetter();
    if (
      !event ||
      !Array.isArray((event as any).odds) ||
      !(event as any).odds.length
    ) {
      return [];
    }

    const firstEventOutcomes = (event as any).odds[0]?.outcome;
    if (!firstEventOutcomes || !firstEventOutcomes.length) {
      return [];
    }
    console.log('columnsfirstEventOutcomes', firstEventOutcomes);
    console.log(
      'columnsArray.isArray(firstEventOutcomes[0])',
      firstEventOutcomes[0]
    );
    // Se è un array di array (nuova struttura)
    if (Array.isArray(firstEventOutcomes[0])) {
      const columnsArray = firstEventOutcomes as PreviewOutcome[][];

      // Verifica se tutte le colonne hanno esattamente un elemento
      const allColumnsHaveSingleElement = columnsArray.every(
        column => column && column.length === 1
      );

      if (allColumnsHaveSingleElement) {
        // Estrai direttamente l'unico elemento da ogni colonna
        return columnsArray.map((column: PreviewOutcome[]) => {
          return column && column.length > 0 ? column[0].outcome_name : '';
        });
      }

      // Comportamento originale: colonne con più elementi
      return columnsArray.map((column: PreviewOutcome[]) => {
        return column && column.length > 0 ? column[0].outcome_name : '';
      });
    }
    console.log('columnsfirstEventOutcomes', firstEventOutcomes);
    // Comportamento originale: array semplice
    return (firstEventOutcomes as PreviewOutcome[]).map(
      (outcome: PreviewOutcome) => outcome.outcome_name
    );
  });
  console.log('columns', columns);
  return { columns };
};

export async function addOddToCartV3FromSport(e: {
  eventId: string | number;
  outcomeUniqueId?: string;
  outcomeId?: number;
  sportId: string;
  sportName: string;
  categoryId: string;
  categoryName: string;
  tournamentId: string;
  tournamentName: string;
  marketId: string | number;
}) {
  console.log('addOddToCartV3FromSport', e);
  await store.dispatch('IllinoisSport/addOddToCartV3FromSport', {
    sportId: e.sportId,
    sportName: e.sportName || '',
    categoryId: e.categoryId,
    categoryName: e.categoryName,
    tournamentId: e.tournamentId,
    tournamentName: e.tournamentName,
    eventId: e.eventId,
    marketId: e.marketId,
    outcomeUniqueId: e.outcomeUniqueId || undefined,
    outcomeId: e.outcomeId || undefined
  });
}

export async function addOddToCartV3FromLive(e: {
  eventId: string | number;
  outcomeUniqueId?: string;
  outcomeId?: number;
  sportId: string;
  sportName: string;
  categoryId: string;
  categoryName: string;
  tournamentId: string;
  tournamentName: string;
  marketId: string | number;
}) {
  console.log('addOddToCartV3FromLive', e);
  await store.dispatch('IllinoisSport/addOddToCartV3FromLive', {
    sportId: e.sportId,
    sportName: e.sportName || '',
    categoryId: e.categoryId,
    categoryName: e.categoryName,
    tournamentId: e.tournamentId,
    tournamentName: e.tournamentName,
    eventId: e.eventId,
    marketId: e.marketId,
    outcomeUniqueId: e.outcomeUniqueId || undefined,
    outcomeId: e.outcomeId || undefined
  });
}

export default useOdds;
